import { NavLink } from "react-router-dom";

// global
import { awsDataStore, userStore } from "../store/Store";

// components
import Avatar from "./Avatar";

// styles and images
import "./Components.css";
import DashboardIcon from "../assets/dashboard_icon.svg";
import SettingsIcon from "../assets/settings.svg";
import InvoiceBlack from "../assets/invoice-black.svg";
import BlackTruck from "../assets/black-truck.svg";
import Driver from "../assets/driver.svg";

export default function Sidebar({ updateShow }) {
  // global
  const currentUser = userStore((userDataStore) => userDataStore.currentUser);
  const profilePic = awsDataStore((data) => data.profilePic);
  const currentCompany = userStore(
    (userDataStore) => userDataStore.currentCompany,
  );
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);

  const handleSettings = () => {
    updateShow(true);
  };
  const handleOther = () => {
    updateShow(false);
  };

  return (
    currentUser &&
    currentCompany &&
    JwtToken && (
      <div className="sidebar">
        <div className="sidebar-content">
          <div className="user">
            <Avatar pic={profilePic} user={currentUser} />
            <p>{currentUser.display_name}</p>
          </div>
          <nav className="links">
            <ul>
              {currentCompany.full_access && (
                <li>
                  <NavLink to="/dashboard" end>
                    <img
                      src={DashboardIcon}
                      alt="dashboard icon"
                      onClick={handleOther}
                    />
                  </NavLink>
                </li>
              )}
              <li>
                <NavLink to="/account-invoices" end>
                  <img
                    src={InvoiceBlack}
                    alt="invoice icon"
                    onClick={handleOther}
                  />
                </NavLink>
              </li>
              {currentCompany.full_access && (
                <li>
                  <NavLink to="/company-carriers" end>
                    <img
                      src={BlackTruck}
                      alt="truck icon"
                      onClick={handleOther}
                    />
                  </NavLink>
                </li>
              )}
              {currentCompany.full_access &&
                currentCompany.pc_carrier_id !== "" && (
                  <li>
                    <NavLink to="/company-drivers">
                      <img
                        src={Driver}
                        alt="driver icon"
                        onClick={handleOther}
                      />
                    </NavLink>
                  </li>
                )}
              <li>
                <NavLink to="/settings/companies">
                  <img
                    src={SettingsIcon}
                    alt="settings icon"
                    onClick={handleSettings}
                  />
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )
  );
}
